'use strict';

angular.module('far.models.user', [])
    .service('User', function ($log, $http) {
        var list = [],
            firstListQuery = true,
            listQueryProgress = false;

        Object.defineProperty(this, 'list', {
            get: function () {
                if (firstListQuery && !listQueryProgress) {
                    listQueryProgress = true;

                    $http.get(Routing.generate(''))
                        .then(function (response) {
                            response.data.forEach(function (routeData) {
                                list.push(new User(routeData));
                            });

                            firstListQuery = false;
                            listQueryProgress = false;
                        }, function errorCallback(response) {
                            listQueryProgress = false;
                            $log.error(response);
                        });
                }

                return list;
            }
        });

        this.new = function (userData) {
            return new User(userData);
        };

        this.delete = function (route, callback) {
            return $http.delete(Routing.generate('api_entities_delete_user', {user: route.id}))
                .then(function () {
                    route = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.restore = function (route) {
            return $http.patch(Routing.generate('api_entities_patch_user', {id: route.id}))
                .then(function () {
                    return route = null;
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.get = function (routeId, callback) {
            var route = new User({});

            $http.get(Routing.generate('api_entities_get_user', {user: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        function User(userData) {
            angular.merge(this, userData);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (userData) {
                        angular.merge(this, userData);

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_entities_put_user', {user: this.id}) :
                                Routing.generate('api_entities_post_user');

                        // TODO: Грязный хак
                        var data = angular.merge({}, this);

                        var objectToId = [
                            'enabled',
                            'gender',
                            'country',
                            'qualification',
                            'instructor_category',
                            'conductor_category',
                            'avatar',
                            'club',
                            'club_position',
                            'club_other',
                            'alpclub',
                            'alpclub_position'
                        ];

                        for ( var key in objectToId ) {
                            var dataName = objectToId[ key ];

                            if ( angular.isObject( data[ dataName ] ) ) {
                                data[ dataName ] = data[ dataName ].id;
                            }
                        }

                        var objectToName = [
                            'region',
                            'city'
                        ];

                        for ( var key in objectToName ) {
                            var dataName = objectToName[ key ];

                            if ( angular.isObject( data[ dataName ] ) ) {
                                data[ dataName ] = data[ dataName ].name;
                            }
                        }

                        data.user_awards = new Array();

                        if ( angular.isObject( data.awards ) ) {
                            for ( var systemName in data.awards ) {
                                var awards = data.awards[ systemName ];

                                if ( angular.isArray( awards ) ) {
                                    for ( var key in awards ) {
                                        if ( angular.isObject( awards[ key].status ) ) {
                                            data.user_awards.push({
                                                status: awards[ key].status.id,
                                                type: awards[ key].type,
                                                year: awards[ key].year,
                                                user: data.id
                                            });
                                        }
                                    }
                                }
                            }
                        }

                        /*['instructor_period_start', 'instructor_period_end', 'birthday', 'member_date_end'].forEach(function(field){
                            if (data[field]) {
                                data[field] = data[field].substr(0, 10).replace('T', ' ');
                            }
                        });*/

                        return $http[method](url, data);
                    }
                }
            });
        }
    });
